export default __webpack_public_path__ + "static/20-3957f483053904ae6480c05930181098.jpg";